import Vue from 'vue';
import Router from 'vue-router';
import Home from './home';
import Auth from './auth';
import Customer from './customer';
import Group from './group';
import Manage from './manage';
import Setting from './setting';
import Node from './node';
import Metting from './metting';
import Staff from './staff';

Vue.use(Router);

export const routes = [
  ...Home,
  ...Auth,
  ...Customer,
  ...Group,
  ...Manage,
  ...Setting,
  ...Node,
  ...Staff,
  ...Metting,
];

const router = new Router({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  const isFirst = localStorage.getItem('isFirst');
  if (!isFirst) {
    localStorage.removeItem('token');
    localStorage.setItem('isFirst', true);
  }
  const token = localStorage.getItem('token');
  if (!token && to.name !== 'auth.login') next('/login');
  else next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js